import axios from "axios"
import { RegistrarLogErro } from "./clientefiel"

const url = localStorage.getItem("teste")
    ? localStorage.getItem("teste")
    : "https://ws.appclientefiel.com.br/rest/"

const api = axios.create({
    baseURL: url,
})

api.interceptors.request.use(config => {
    try {
        config.headers.common["sistema"] = "painel"

        const windowName = window.name
        if (windowName) config.headers.common["identificador"] = windowName

        return config
    } catch (error) {
        console.log("Error API Interceptor", error)
        RegistrarLogErro(error, "API Interceptor", { config })

        return config
    }
})

export default api
